import { DateTime } from "luxon";

function dateTime(dateString, options = {}) {
	const { zone = "utc" } = options;

	let datetime = null;

	// ISO 8601
	datetime = DateTime.fromISO(dateString, { zone });
	if (datetime.isValid) return datetime;

	// Modified ISO 8601 ('/' instead of '-')
	datetime = DateTime.fromFormat(dateString, "yyyy/MM/dd", { zone });
	if (datetime.isValid) return dateTime;

	// Check our own custom format
	datetime = DateTime.fromFormat(dateString, "MM/dd/yyyy");
	if (datetime.isValid) return datetime;

	console.warn("Failed to parse date", dateString, { zone });
	return null;
}

function time(timeString, options = {}) {
	const { zone = "utc" } = options;

	if (!timeString) return null;

	let time = null;

	// ISO 8601
	time = DateTime.fromISO(timeString, { zone });
	if (time.isValid) return time;

	// Custom format "HH:MM (AM|PM)"
	time = DateTime.fromFormat(timeString, "h:mm a", { zone });
	if (time.isValid) return time;

	console.warn("Failed to parse time", timeString, { zone });
	return null;
}

export default {
	dateTime,
	time,
};
